function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, cloneElement } from 'react';
import cn from 'classnames';
import { Badge } from '../Badge';
require("./BadgeContainer.css");
var styles = {
  "Root": "BadgeContainer-module-Root_1LF",
  "Badge": "BadgeContainer-module-Badge_3C5"
};
export const BadgeContainer = ({
  children,
  className,
  controlRef,
  innerRef,
  tag = 'div',
  ...props
}) => {
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: innerRef
  }, props, {
    className: cn(styles.Root, className)
  }), Children.map(children, child => {
    if (child?.type !== Badge) return child;
    return /*#__PURE__*/cloneElement(child, {
      className: styles.Badge
    });
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BadgeContainer.displayName = 'BadgeContainer';
}